
/* Order status fields */
const NEW = 'new'
const CANCELED = 'canceled'
const FINISHED = 'finish'

const PICKUP = 'self'
const DELIVERY = 'delivery'

const CASH = "cash"
const DEBT = "debt"
const QR = "qr"

const PAID = "paid"
const NOTPAID = "notpaid"
const REZERV = "reserve"





/* PRICE CONVERTOR */
const convertor = price => {

    /* Check the price for the void */
    if (price === null || price === undefined)
        return ""

    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " ₸"
}


/* CHECK DATA */
const check = data => {
    if (data && data !== undefined && data !== null) {
        return data
    }

    return "-"
}


/* ORDER DELIVERY TYPE */
const deliveryType = delivery => {
    if (delivery === PICKUP) {
        return <div className="tag purple">Самовывоз</div>
    }
    if (delivery === DELIVERY) {
        return <div className="tag darkblue">Доставка</div>
    }
}

/* ORDER STATUS */
const order_status = delivery => {
    if (delivery === NEW) {
        return <div className="tag purple">Новый</div>
    }
    if (delivery === CANCELED) {
        return <div className="tag red">Отменен</div>
    }
    if (delivery === FINISHED) {
        return <div className="tag darkblue">Завершен</div>
    }
}


/* ORDER PAYMENT TYPE */
const paymentType = payment => {
    if (payment === CASH) {
        return <div className="tag pink">Наличные</div>
    }
    if (payment === QR) {
        return <div className="tag darkblue">QR</div>
    }
    if (payment === DEBT) {
        return <div className="tag darkblue">Долг</div>
    }
}


/* ORDER PAYMENT STATUS */
const paymentStatus = status => {
    if (status === PAID) {
        return <div className="tag green">Оплачен</div>
    }
    if (status === NOTPAID) {
        return <div className="tag red">Не оплачен</div>
    }
    if (status === REZERV) {
        return <div className="tag yellow">Резерв</div>
    }
}


/* DELVERY TYPE LIST */
const DELIVERY_TYPE = [
    { key: PICKUP, text: 'Самовывоз', color: 'purple' },
    { key: DELIVERY, text: 'Доставка', color: 'darkblue' },
]

/* PAYMENT TYPE LIST */
const PAYMENT_TYPE = [
    { key: CASH, text: 'Наличные', color: 'pink' },
    { key: DEBT, text: 'Долг', color: 'pink' },
    { key: QR, text: 'QR', color: 'pink' },
]

/* PAYMENT STATUS LIST */
const PAYMENT_STATUS = [
    { key: PAID, text: 'Оплачен', color: 'green' },
    { key: NOTPAID, text: 'Не оплачен', color: 'red' },
    { key: REZERV, text: 'Резерв', color: 'yellow' },
]


/* TRANSLIT */
const translit = word => {

    let text = ''

    const converter = {
        'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd',
        'е': 'e', 'ё': 'e', 'ж': 'zh', 'з': 'z', 'и': 'i',
        'й': 'y', 'к': 'k', 'л': 'l', 'м': 'm', 'н': 'n',
        'о': 'o', 'п': 'p', 'р': 'r', 'с': 's', 'т': 't',
        'у': 'u', 'ф': 'f', 'х': 'h', 'ц': 'c', 'ч': 'ch',
        'ш': 'sh', 'щ': 'sch', 'ь': '', 'ы': 'y', 'ъ': '',
        'э': 'e', 'ю': 'yu', 'я': 'ya',

        'А': 'a', 'Б': 'b', 'В': 'b', 'Г': 'g', 'Д': 'd',
        'Е': 'e', 'Ё': 'e', 'Ж': 'zh', 'З': 'z', 'И': 'i',
        'Й': 'y', 'К': 'k', 'Л': 'l', 'М': 'm', 'Н': 'n',
        'О': 'o', 'П': 'p', 'Р': 'r', 'С': 's', 'Т': 't',
        'У': 'u', 'Ф': 'f', 'Х': 'H', 'Ц': 'C', 'Ч': 'ch',
        'Ш': 'sh', 'Щ': 'sch', 'Ь': '', 'Ы': 'y', 'Ъ': '',
        'Э': 'e', 'Ю': 'yu', 'Я': 'ya'
    }


    for (let i = 0; i < word.length; ++i) {
        if (word[i] === " ") {
            text += "-"
        }
        else if (converter[word[i]] === undefined || converter[word[i]] === null) {
            text += word[i]
        }
        else {
            text += converter[word[i]]
        }
    }

    return text

}


/* PHONE FORMATTER */
const formatter = (phone, mask) => {

    if (phone === null || phone === undefined || phone === "") {
        return "-"
    }

    if (!mask) return phone

    const numeric = phone.replaceAll(/[^\d]/g, '')

    let idx = 0

    const formated = mask.split('').map(el => {

        if (el === '#') {
            el = numeric[idx]
            idx++
        }

        return el
    })

    return formated.join('')
}


/* GENDER */
const gender = gender => {

    if (gender === undefined || gender === null) {
        return "-"
    }

    if (parseInt(gender) === 1) {
        return "Мужской"
    }
    if (parseInt(gender) === 2) {
        return "Женский"
    }

    return "-"
}



/*
    Check Number
*/
const isNumeric = value => {
    return /^-?[\d.]+(?:e-?\d+)?$/.test(value)
}

/* Divide number */
const numberWithSpaces = (x) => {
    if (x === null || x === undefined) return ''
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
}


export { formatter, check, deliveryType, paymentType, order_status, paymentStatus, convertor, DELIVERY_TYPE, PAYMENT_TYPE, PAYMENT_STATUS, translit, gender, isNumeric, numberWithSpaces }